<template>
  <v-layout row justify-center>
    <v-dialog v-if="userData" persistent v-model="dialog" max-width="700">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pr-2">edit</v-icon>
            Notes for {{ userData.email }}
          </span>
          <v-btn absolute right depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="edit_user" data-vv-scope="edit_user" lazy-validation>
            <v-layout v-if="loading" row justify-center py-5 >
              <v-progress-circular
                :size="150"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </v-layout>
            <v-layout v-else row wrap pb-3>
              <v-flex xs5 style="margin: auto;">
                Note:
              </v-flex>
              <v-flex xs7 pt-3>
                <v-textarea
                  v-model="admin_note"
                  rows="3"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveNote()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'EditUserNoteModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['editNoteDialog', 'userData', 'loading'],
  data () {
    return {
      dialog: this.editNoteDialog,
      admin_note: this.userData.admin_note,
      rules: {
        required: value => (!!value || value === 0) || 'Required.'
      }
    }
  },
  watch: {
    editNoteDialog: {
      handler () {
        this.dialog = this.editNoteDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('editNoteDialog', this.dialog)
      }
    }
  },
  methods: {
    saveNote () {
      this.$parent.$emit('loading', true)
      let params = {
        admin_note: this.admin_note
      }
      this.$store.dispatch('EDIT_USER', { userId: this.userData.id, newData: params }).then(res => {
        this.$parent.$emit('loading', false)
        this.$parent.$emit('updateUsersList')
        this.$toasted.show('User note was successfully edited')
        this.closeModal()
      }, err => {
        console.log('EDIT_USER error', err)
        this.$parent.$emit('loading', false)
        let errorText = this.$services.getApiError(err)
        if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/EditUserNoteModal.vue